/**
 * Feature Flags Configuration
 *
 * Centralized feature flag management for gradual rollout
 * and A/B testing of new features.
 */

/**
 * Projects Feature Flag
 *
 * Controls visibility of NEW Projects UX:
 * - Projects routes (/projects/*)
 * - Projects navigation tabs
 * - "New Project" button
 * - Project browsing/linking UI
 * - SessionsPickerModal, LinkedSessionsPanel
 *
 * @type {boolean}
 * @default true - New Projects UX enabled
 */
export const PROJECTS_ENABLED = true;

/**
 * Convert to Project Feature Flag
 *
 * Controls the legacy "Convert to Project" functionality:
 * - "Convert to Project" menu items
 * - Session → Project conversion (old model)
 *
 * This is separate from PROJECTS_ENABLED to allow conversion
 * to work without exposing the full Projects browsing UI.
 *
 * @type {boolean}
 * @default true - Conversion allowed even when Projects UX is hidden
 */
export const PROJECTS_CONVERT_ENABLED = true;

export default {
  PROJECTS_ENABLED,
  PROJECTS_CONVERT_ENABLED
};
